import { createGlobalStyle } from "styled-components";
import { darkGrey, white } from "./colors";

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-family: Sans-Serif;
    background-color: ${darkGrey};
    scroll-behavior: smooth;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  a {
    cursor: pointer;
    text-decoration:none;
  }
 
  ul, li, h1, h2, h3, p  {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: none;
  }

  button {
    border: 0;
    outline: 0;
  }

  body {
    max-width: 1920px;
    margin: 0 auto;
    background-color: ${white};
    color: ${darkGrey};
    overscroll-behavior: none;
    width: 100%;
  }

  body {
    margin: 0 auto;
    /* overscroll-behavior: none; */
    width: 100%;
  }

  #app {
    box-shadow: 0 0 10px rgba(0,0,0,.05);
    overflow-x: hidden;
  }
`;
